(function () {
  'use strict';

  var VERSION = '7';
  var scheduled = false;
  var observedCart = null;
  var cartObserver = null;

  var NAV_LINKS = [
    ['New Arrivals','/collections/new-arrivals'],
    ['Winter','/collections/winter-clothes-for-women'],
    ['Sets','/collections/sets-jumpsuits'],
    ['Dresses & Abayas','/collections/abayas'],
    ['Last Chance','/collections/last-chance-picks']
  ];

  function normalizePath(href) {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (e) {
      return href || '';
    }
  }

  function isCurrent(path) {
    return (window.cazaPath ? window.cazaPath() : window.location.pathname).indexOf(path) === 0;
  }

  function navMatches(container, mobile) {
    if (!container) return false;
    var items = Array.prototype.slice.call(container.children).filter(function (node) {
      return node.tagName === 'LI';
    });
    if (items.length !== NAV_LINKS.length) return false;

    return NAV_LINKS.every(function (item, index) {
      var link = items[index] && items[index].querySelector('a');
      var text = items[index] && items[index].querySelector('.t4s-nav_link_txt');
      if (!link || !text) return false;
      return normalizePath(link.getAttribute('href')) === normalizePath((window.cazaL ? window.cazaL(item[1]) : item[1])) &&
        text.textContent.trim() === (window.cazaT ? window.cazaT(item[0]) : item[0]);
    });
  }

  function applyDesktopNav() {
    var nav = document.getElementById('t4s-nav-ul');
    if (!nav || navMatches(nav, false)) return;

    nav.dataset.cazaFirstFold = VERSION;
    nav.innerHTML = NAV_LINKS.map(function (item) {
      return '<li class="t4s-type__simple t4s-menu-item' +
        (isCurrent(item[1]) ? ' is--nav__active' : '') +
        '"><a class="t4s-lh-1 t4s-d-flex t4s-align-items-center t4s-pr" href="' +
        (window.cazaL ? window.cazaL(item[1]) : item[1]) + '"><span class="t4s-nav_link_txt">' + (window.cazaT ? window.cazaT(item[0]) : item[0]) + '</span></a></li>';
    }).join('');
  }

  function applyMobileNav() {
    var ul = document.getElementById('menu-mb__ul');
    if (!ul || navMatches(ul, true)) return;

    ul.dataset.cazaFirstFold = VERSION;
    ul.innerHTML = NAV_LINKS.map(function (item) {
      return '<li class="t4s-menu-item t4s-item-level-0' +
        (isCurrent(item[1]) ? ' is--current' : '') +
        '"><a href="' + (window.cazaL ? window.cazaL(item[1]) : item[1]) +
        '"><span class="t4s-nav_link_txt t4s-d-flex t4s-align-items-center">' +
        (window.cazaT ? window.cazaT(item[0]) : item[0]) + '</span></a></li>';
    }).join('');
  }

  function injectCriticalStyle() {
    if (document.getElementById('caza-runtime-hotfix-v7')) return;

    var style = document.createElement('style');
    style.id = 'caza-runtime-hotfix-v7';
    style.textContent =
      '@media (max-width:767px){' +
      'html.is--opend-drawer .t4s-sticky-atc,' +
      'html.caza-mini-cart-open .t4s-sticky-atc{' +
      '-webkit-transform:translate3d(0,110%,0)!important;' +
      'transform:translate3d(0,110%,0)!important;' +
      'opacity:0!important;' +
      'visibility:hidden!important;' +
      'pointer-events:none!important;' +
      '}' +
      '#t4s-mini_cart .t4s-drawer__bottom{' +
      'padding-bottom:calc(20px + env(safe-area-inset-bottom))!important;' +
      '}' +
      '}' +
      '@supports selector(html:has(*)){' +
      '@media (max-width:767px){' +
      'html:has(#t4s-mini_cart[aria-hidden="false"]) .t4s-sticky-atc{' +
      '-webkit-transform:translate3d(0,110%,0)!important;' +
      'transform:translate3d(0,110%,0)!important;' +
      'opacity:0!important;' +
      'visibility:hidden!important;' +
      'pointer-events:none!important;' +
      '}' +
      '}' +
      '}';
    document.head.appendChild(style);
  }

  function isMiniCartOpen(cart) {
    if (!cart) return false;
    return cart.getAttribute('aria-hidden') === 'false' ||
      cart.classList.contains('is--open') ||
      cart.classList.contains('is--opened') ||
      cart.classList.contains('is--active');
  }

  function syncMiniCartState() {
    var cart = document.getElementById('t4s-mini_cart');
    document.documentElement.classList.toggle('caza-mini-cart-open', isMiniCartOpen(cart));
  }

  function fixMiniCartReturnLink() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;

    drawer.querySelectorAll('.t4s-return-to-shop a').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/collections/womens-clothes') !== -1) {
        link.setAttribute('href', window.cazaL ? window.cazaL('/collections/new-arrivals') : '/collections/new-arrivals');
      }
    });
  }

  function ensureCartObserver() {
    var cart = document.getElementById('t4s-mini_cart');
    if (!cart || cart === observedCart) return;

    if (cartObserver) cartObserver.disconnect();
    observedCart = cart;
    cartObserver = new MutationObserver(function () {
      syncMiniCartState();
      fixMiniCartReturnLink();
    });
    cartObserver.observe(cart, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
      childList: true,
      subtree: true
    });
    syncMiniCartState();
  }

  function applyAll() {
    injectCriticalStyle();
    applyDesktopNav();
    applyMobileNav();
    fixMiniCartReturnLink();
    ensureCartObserver();
    syncMiniCartState();
    document.documentElement.dataset.cazaRuntimeHotfix = VERSION;
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyAll();
    });
  }

  function startHydrationObserver() {
    if (document.documentElement.dataset.cazaHydrationObserver === VERSION) return;
    document.documentElement.dataset.cazaHydrationObserver = VERSION;

    new MutationObserver(scheduleApply).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    applyAll();
    startHydrationObserver();
    window.setTimeout(applyAll, 350);
    window.setTimeout(applyAll, 1100);
    window.setTimeout(applyAll, 2200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', scheduleApply);
})();
